import React, { useReducer } from 'react';
import Manual from '../index';
import { reducer } from './reducer';

export default function MultiManual({ components }, ...props) {
    const INITIAL_STATE = {
        id: components[0].id,
        message: components[0].message,
        padding: components[0].padding,
        rect: components[0].rect,
        copyConfigurations: components[0].copyConfigurations,
        hasNext: components.length > 1,
        hasBefore: false,
        counter: 0,
    };

    const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

    function onNext() {
        dispatch({ type: 'next', components });
    }

    function onBefore() {
        dispatch({ type: 'prev', components });
    }

    function onFinish() {
        dispatch({ type: 'reset', components });
    }

    return (
        <Manual
            idComponent={state.id}
            hasBefore={state.hasBefore}
            hasNext={state.hasNext}
            message={state.message}
            padding={state.padding}
            rect={state.rect}
            copyConfigurations={state.copyConfigurations}
            onFinish={onFinish}
            onNext={onNext}
            onBefore={onBefore}
            {...props}
        />
    );
}